import React, { useEffect, useState } from 'react'
import uuid from 'react-native-uuid'
import { deleteObject, storage, getDownloadURL, ref, uploadString } from '~providers/firebase'
import DiagnosticsResult from '../DiagnosticsResult'
import { Status } from '../types'

export default function FirebaseStorageChecker(): React.JSX.Element {
  const [status, setStatus] = useState<Status>('inprogress')
  const [error, setError] = useState<Error>()

  useEffect(() => {
    let cancel = false

    async function ping() {
      try {
        const fileRef = ref(storage, `diagnostics/${uuid.v4()}.txt`)

        // Write "pong"
        await uploadString(fileRef, 'cG9uZw==', 'base64', {
          contentType: 'text/plain',
        })

        // Get URL
        const url = await getDownloadURL(fileRef)

        // Read
        const result = await fetch(url)
        const text = await result.text()
        if (result.status !== 200 || text !== 'pong') {
          throw new Error(
            `Unexpected download response [code=${result.status} data=${JSON.stringify(text)}]`,
          )
        }

        // Delete
        await deleteObject(fileRef)

        if (!cancel) {
          setStatus('success')
          setError(undefined)
        }
      } catch (error) {
        if (!cancel) {
          setStatus('failed')
          setError(error)
        }
      }
    }

    ping()

    return () => {
      cancel = true
    }
  }, [])

  return (
    <DiagnosticsResult
      title="Firebase Storage"
      description="Read/write/delete operation on storage"
      status={status}
      error={error}
    />
  )
}
